import { Box } from "@mui/joy";
import React from "react";
import { centrado } from "../utils/Estilos";
import nosotros from "../assets/banner/nosotrosp.jpg";
import { Grid2, Typography } from "@mui/material";
import { Helmet } from "react-helmet";

export const Terminos = () => {
  return (
    <Box sx={{ ...centrado, width: "100%", flexWrap: "wrap" }}>
      <Helmet>
        <title>{"Publimed Store - Términos y Condiciones"}</title>
      </Helmet>
      <Box
        sx={{
          backgroundImage: "url(" + nosotros + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "400px",
          width: "100%",
        }}
      />
      <Grid2 container sx={{ width: "80%", ...centrado }} py={2}>
        <Grid2 size={{ xs: 12, md: 10 }} sx={{ padding: "20px" }}>
          <Typography variant="h5" fontWeight={"bold"} color="primary" pt={5}>
            Terms and Conditions
          </Typography>
          <Typography variant="h6" pt={5}>
            This website is operated by Angel España, owner of Grupo Publimed.
            Throughout the site, the terms “we”, “us” and “our” refer to Angel
            España/ Grupo Publimed. By visiting our site and/or purchasing
            something from us, you engage in our “Service” and agree to be bound
            by the following terms and conditions.
          </Typography>
          <Typography variant="h6" pt={2}>
            Services: We provide medical education, residency exam simulators,
            and academic advisory services.
          </Typography>
          <Typography variant="h6" pt={2}>
            Governing Law: These Terms of Service and any separate agreements
            whereby we provide you Services shall be governed by and construed
            in accordance with the laws of the Republic of Ecuador.
          </Typography>
          <Typography variant="h6" pt={2}>
            Intellectual Property: All content provided on this site, including
            simulators and educational materials, is the property of Angel
            España and is protected by international copyright laws.
          </Typography>
          <Typography variant="h6" pt={2}>
            Contact Information: Questions about the Terms of Service should be
            sent to us at ventas@publimed.net.
          </Typography>

          <Typography variant="h6" pt={4}>
            <strong> Legal Information of the Administrator: </strong>
            <br />
            The website www.publimed.net is managed by Angel Javier
            España Mojarrango, as a natural person with commercial activity, identified with the number of ID: 0803715986. <br />
            Official contact: administracion@publimed.net
          </Typography>
        </Grid2>
      </Grid2>
    </Box>
  );
};
